export const SITE_IN_A_BOX_STATUS = {
    QUOTED: "quoted",
    ORDERED: "ordered",
    LIVE: "live",
    CANCELLED: "cancelled",
};
export const SITE_IN_A_BOX_DEFAULT_STATUS = SITE_IN_A_BOX_STATUS.QUOTED;
export const SITE_IN_A_BOX_STATUS_LABELS = {
    [SITE_IN_A_BOX_STATUS.QUOTED]: "Quoted",
    [SITE_IN_A_BOX_STATUS.ORDERED]: "Ordered",
    [SITE_IN_A_BOX_STATUS.LIVE]: "Live",
    [SITE_IN_A_BOX_STATUS.CANCELLED]: "Cancelled",
};
/** Only Quoted line items may be edited via the form. */
export function canEditSiteInABoxItem(status) {
    return status === SITE_IN_A_BOX_STATUS.QUOTED;
}
export function canMarkSiteInABoxAsLive(status) {
    return status === SITE_IN_A_BOX_STATUS.ORDERED;
}
export function canMarkSiteInABoxAsCancelled(status) {
    return (status === SITE_IN_A_BOX_STATUS.QUOTED ||
        status === SITE_IN_A_BOX_STATUS.ORDERED);
}
